export default __webpack_public_path__ + "static/media/logo.381ef020.png";